<template minapp='mpx' xlang='wxml'>
  <view bindtouchstart="touchStart" bindtouchmove="touchMove" bindtouchend="touchEnd">
    <!-- 下拉刷新的view -->
    <view class="pulldown" wx:style="transform:{{transformY}};" wx:if="{{showPullDown}}">
      <image src="{{loadingImg}}" class="pulldown-loading"/>
      <view class="pulldown-text">松开立即刷新</view>
    </view>
    <view wx:style="transform:{{transformY}};">
      <slot />
    </view>
  </view>
</template>

<script>
  import { createComponent,mpx } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      isShowLoading:{
        type: Boolean,
        value: true
      },
      loadingImg:{
        type: String,
        value: 'https://pt-starimg.didistatic.com/static/starimg/img/Hc2LzFVPzU1652950957080.png',
      },
      canPullDown:{
        type: Boolean,
        value: true
      },
      useEffectOfIos: { //使用与否取决与<slot />的高度是否超过屏幕高度达到滚动效果，此处将参数放开
        type: Boolean,
        value: true
      }
    },
    
    data: {
      clientY: -1, //滑动开始时Y
      touchStartHeight: 0, //滑动touchstart的距离顶部高度
      platform: 'android', //设备
      changeClientY: 0,
      showPullDown: false,
    },

    // 获取设备类型
    attached() {
      if(this.useEffectOfIos){
        mpx.getSystemInfo().then((e) => {
          this.platform = e.platform
        })
      }
    },

    computed: {
      // 向下滑动的距离
      transformY() {
        // ios使用原生滑动
        if (this.platform === 'ios') {
          return 'translateY(0px)'
        } else {
          return 'translateY(' + this.changeClientY + 'px)'
        }
      },
    },

    methods: {
      // touchStart获取滑动开始的Y坐标
      touchStart(e) {
        this.clientY = e.changedTouches[0].clientY
        this.touchStartHeight = this.recordScrollHeight
      },
      touchMove(e) {
        // 获取滑动中的y值
        let clientY = e.changedTouches[0].clientY
        // 如果时顶部开始滑动，并且像下滑动，就改变tranlate等于改变的差值
        if (this.canPullDown && clientY > this.clientY && this.clientY !== -1) {
        // if (this.touchStartHeight < 5 && clientY > this.clientY) {
          let changY = Math.trunc(clientY - this.clientY)
          if (this.platform !== 'ios') {
            this.changeClientY = changY > 90 ? 90 : changY
          }
          this.showPullDown = true
        }
      },
      touchEnd(e) {
        if (this.canPullDown && this.clientY !== -1) {
          let clientY = e.changedTouches[0].clientY
          let changY = Math.trunc(clientY - this.clientY)
          if (this.platform !== 'ios') {
            this.changeClientY = 0
          }
          if (changY > 90) {
            this.refresherRefresh()
          }
        }
        this.showPullDown = false
      },
      // 触发下拉刷新事件
      async refresherRefresh() {
        if (__mpx_mode__ === 'web' && this.isShowLoading) {
          mpx.showLoading()
        }
        await this.$trigger('refresh')
        if (__mpx_mode__ === 'web' && this.isShowLoading) {
          setTimeout(() => {
            mpx.hideLoading()
          }, 200)
        }
      },
    }
  })
</script>

<style lang='stylus'>
  @import '../common/style/bem'

  .pulldown
    display flex
    justify-content center
    align-items center
    width 100%
    height 40px
  .pulldown-text
    font-size 14px
    color #FFFFFF
    padding-right 28px
  .pulldown-loading
    width 20px
    height 20px
    margin-right 15px
    animation spin 2s linear infinite
  @keyframes spin
    0%
      transform rotate(0deg)
    100%
      transform rotate(360deg)
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
    }
  }
</script>

